function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import ListOption from './ListOption';
var propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  id: PropTypes.string,
  selected: PropTypes.array,
  useCheckbox: PropTypes.bool,
  multiselect: PropTypes.bool,
  ariaLabelledBy: PropTypes.string,
  ariaLabel: PropTypes.string,
  options: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
    icon: PropTypes.node
  })),
  activeOption: PropTypes.string,
  onItemSelect: PropTypes.func,
  standalone: PropTypes.bool,
  onFocus: PropTypes.func,
  onBlur: PropTypes.func
};
var defaultProps = {
  selected: []
};

var Listbox = function Listbox(_ref) {
  var _ref2;

  var ariaLabel = _ref.ariaLabel,
      ariaLabelledBy = _ref.ariaLabelledBy,
      activeOption = _ref.activeOption,
      className = _ref.className,
      id = _ref.id,
      multiselect = _ref.multiselect,
      onItemSelect = _ref.onItemSelect,
      onFocus = _ref.onFocus,
      onBlur = _ref.onBlur,
      options = _ref.options,
      useCheckbox = _ref.useCheckbox,
      standalone = _ref.standalone,
      selected = _ref.selected;

  var _useState = useState(''),
      _useState2 = _slicedToArray(_useState, 2),
      activeId = _useState2[0],
      setActive = _useState2[1];

  var _useState3 = useState(selected),
      _useState4 = _slicedToArray(_useState3, 2),
      selectedArray = _useState4[0],
      setSelected = _useState4[1];

  useEffect(function () {
    setActive(activeOption);
  }, [activeOption]);
  useEffect(function () {
    setSelected(selected);
  }, [selected]);

  var handleSelect = function handleSelect(item) {
    onItemSelect && onItemSelect(item);
  };

  return /*#__PURE__*/React.createElement("ul", _extends({
    className: className,
    role: "listbox",
    "aria-multiselectable": multiselect
  }, standalone && (_ref2 = {}, _defineProperty(_ref2, 'aria-activedescendant', activeId), _defineProperty(_ref2, "tabIndex", 0), _ref2), {
    "aria-label": ariaLabel,
    "aria-labelledby": ariaLabelledBy,
    id: id,
    onFocus: onFocus,
    onBlur: onBlur
  }), options.map(function (item, index) {
    var itemId = "".concat(id, "_").concat(item.value);
    return /*#__PURE__*/React.createElement(ListOption, {
      key: item.value,
      value: item.value,
      id: itemId,
      label: item.label,
      className: itemId === activeId ? 'bgcolor--highlight' : '',
      useCheckbox: useCheckbox,
      onClick: handleSelect,
      selected: selectedArray.includes(index) || selectedArray.includes(item.value)
    }, /*#__PURE__*/React.createElement("div", {
      className: "display-flex justify-content-between width-100p"
    }, item.label, item.icon));
  }));
};

Listbox.propTypes = propTypes;
Listbox.defaultProps = defaultProps;
Listbox.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "Listbox",
  "props": {
    "selected": {
      "defaultValue": {
        "value": "[]",
        "computed": false
      },
      "type": {
        "name": "array"
      },
      "required": false,
      "description": ""
    },
    "children": {
      "type": {
        "name": "node"
      },
      "required": false,
      "description": ""
    },
    "className": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "id": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "useCheckbox": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "multiselect": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "ariaLabelledBy": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "ariaLabel": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "options": {
      "type": {
        "name": "arrayOf",
        "value": {
          "name": "shape",
          "value": {
            "label": {
              "name": "string",
              "required": true
            },
            "value": {
              "name": "string",
              "required": true
            },
            "icon": {
              "name": "node",
              "required": false
            }
          }
        }
      },
      "required": false,
      "description": ""
    },
    "activeOption": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "onItemSelect": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "standalone": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "onFocus": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "onBlur": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    }
  }
};
export default Listbox;